import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { CartProvider } from './context/CartContext';
import { AuthProvider } from './context/AuthContext';
import PromoBar from './components/PromoBar';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import ProductsSection from './components/ProductsSection';
import BrandStorySection from './components/BrandStorySection';
import ProcessSection from './components/ProcessSection';
import HighlightSection from './components/HighlightSection';
import CommunitySection from './components/CommunitySection';
import ReviewsSection from './components/ReviewsSection';
import TestimonialsSection from './components/TestimonialsSection';
import FAQSection from './components/FAQSection';
import NewsletterSection from './components/NewsletterSection';
import Footer from './components/Footer';
import CartDrawer from './components/CartDrawer';
import FloatingCart from './components/FloatingCart';
import PromoPopup from './components/PromoPopup';
import AnalyticsTracker from './components/AnalyticsTracker';
import AuthPage from './pages/AuthPage';
import ProfilePage from './pages/ProfilePage';
import AdminPage from './pages/AdminPage';
import './App.css';

const HomePage = () => {
  return (
    <>
      <PromoBar />
      <Header />
      <main>
        <HeroSection />
        <ProductsSection />
        <BrandStorySection />
        <ProcessSection />
        <HighlightSection />
        <TestimonialsSection />
        <ReviewsSection />
        <CommunitySection />
        <FAQSection />
        <NewsletterSection />
      </main>
      <Footer />
      <CartDrawer />
      <FloatingCart />
      <PromoPopup />
    </>
  );
};

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <BrowserRouter>
          <AnalyticsTracker />
          <div className="app">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/prijava" element={<AuthPage mode="login" />} />
              <Route path="/registracija" element={<AuthPage mode="register" />} />
              <Route path="/profil" element={<ProfilePage />} />
              <Route path="/admin" element={<AdminPage />} />
            </Routes>
          </div>
        </BrowserRouter>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
